export default __webpack_public_path__ + "static/media/setion02_bg_m.4aa39602.png";